import * as React from "react";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemText from "@mui/material/ListItemText";
import { Divider, ListItemIcon } from "@mui/material";
//import SyncProblemIcon from "@mui/icons-material/SyncProblem";
//import SyncIcon from "@mui/icons-material/Sync";
//import CloseIcon from "@mui/icons-material/Close";
import { listPopoverProps } from "../../helpers";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import { DATEFORMATS } from "../../../globals/globals";
import StatusIcon from "../Status/StatusIcon";

dayjs.extend(utc);
interface IListSecondaryProps {
  listData: Array<any>;
  onRowClickHandler: (event: React.MouseEvent, rowId: number) => void;
}

const ListSecondary: React.FC<IListSecondaryProps> = ({ listData, onRowClickHandler }) => {
  return (
    <List dense sx={{ ...listPopoverProps, width: "100%", bgcolor: "var(--card)", overflowY: "auto", pt: 0, pb: 0 }}>
      {listData.map((item, index) => {
        const labelId = `list-secondary-${item.id}`;
        const newdate = dayjs(item.lastUpdatedTS).format(DATEFORMATS.TSN);
        return (
          <>
            <ListItem
              key={item.id}
              // secondaryAction={
              //   <IconButton sx={{ "&:hover": { backgroundColor: "var(--secondary)" } }}>
              //     <CloseIcon fontSize="small" sx={{ color: "var(--text-primary)" }} />
              //   </IconButton>
              // }
              disablePadding
            >
              <ListItemButton onClick={(e) => onRowClickHandler(e, item.id)}>
                <ListItemIcon sx={{ minWidth: 40 }}>
                  {/* {item.status === "Fail" ? <SyncProblemIcon color="error" /> : <SyncIcon sx={{ color: "var(--text-primary)" }} />} */}
                  <StatusIcon status={item.status} isLabel={false} />
                </ListItemIcon>
                <ListItemText
                  id={labelId}
                  primary={item.description}
                  secondary={newdate}
                  primaryTypographyProps={{ sx: { color: "var(--subtle-foreground)", fontWeight: "bold" } }}
                />
              </ListItemButton>
            </ListItem>
            {listData.length - 1 > index && <Divider />}
          </>
        );
      })}
    </List>
  );
};

export default ListSecondary;
